import React, { useState, useEffect } from 'react';
import { FaTrophy, FaMedal, FaSpinner } from 'react-icons/fa';
import { calculateStandings } from '../utils/api';
import './Standings.css';

const Standings = () => {
  const [standings, setStandings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStandings = async () => {
      try {
        setLoading(true);
        const data = await calculateStandings();
        
        if (data.error) {
          setError(data.message);
        } else {
          setStandings(data);
        }
      } catch (err) {
        setError('Failed to load standings. Please try again later.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStandings();
  }, []);

  if (loading) {
    return (
      <div className="container">
        <div className="page-title">
          <FaTrophy />
          <h1>Ställning</h1>
        </div>
        <div className="loading">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        <div className="page-title">
          <FaTrophy />
          <h1>Ställning</h1>
        </div>
        <div className="error">{error}</div>
      </div>
    );
  }

  // Get unique course names from the first standing's coursePoints
  const courseNames = standings.length > 0 
    ? Object.keys(standings[0].coursePoints)
    : [];

  return (
    <div className="container">
      <div className="page-title">
        <FaTrophy />
        <h1>Ställning</h1>
      </div>

      <div className="card">
        <h2>Total ställning</h2>
        <div className="table-responsive">
          <table className="standings-table">
            <thead>
              <tr>
                <th className="position-col">Plats</th>
                <th className="player-col">Spelare</th>
                <th className="points-col">Poäng</th>
                {courseNames.map(course => (
                  <th key={course} className="course-col">{course}</th>
                ))}
                <th className="details-col">Placeringar (1/2/3)</th>
              </tr>
            </thead>
            <tbody>
              {standings.map((player, index) => (
                <tr key={player.id} className={index < 3 ? `rank-${index + 1}` : ''}>
                  <td className="position-col">
                    {index === 0 && <FaTrophy className="gold-trophy" />}
                    {index === 1 && <FaMedal className="silver-medal" />}
                    {index === 2 && <FaMedal className="bronze-medal" />}
                    {index > 2 && index + 1}
                  </td>
                  <td className="player-col">{player.name}</td>
                  <td className="points-col">{player.totalPoints}</td>
                  {courseNames.map(course => (
                    <td key={course} className="course-col">
                      {player.coursePoints[course] || 0}
                    </td>
                  ))}
                  <td className="details-col">
                    {player.firstPlaces}/{player.secondPlaces}/{player.thirdPlaces}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <h2>Poängsystem</h2>
        <p>
          Poäng baseras på en spelares tre bästa resultat på varje bana. För varje position 
          (bästa, näst bästa, tredje bästa) rankas spelarna och poäng delas ut enligt följande:
        </p>
        <ul className="scoring-rules">
          <li><strong>1:a plats:</strong> 3 poäng</li>
          <li><strong>2:a plats:</strong> 2 poäng</li>
          <li><strong>3:e plats:</strong> 1 poäng</li>
          <li><strong>4:e plats eller sämre:</strong> 0 poäng</li>
        </ul>
        <p>
          En spelare kan få maximalt 9 poäng per bana (om de har det bästa resultatet i alla tre positioner).
          Vid oavgjort på totalpoäng avgörs placeringen av antalet förstaplaceringar, följt av andraplaceringar 
          och så vidare.
        </p>
      </div>
    </div>
  );
};

export default Standings; 